var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.25,
    fill: "#ECECEC",
    stroke: "#183883",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1603_31263",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 26,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1603_31263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 56H39V52H44C44.5667 52 45.0417 51.8083 45.425 51.425C45.8083 51.0417 46 50.5667 46 50V46C46 45.4333 45.8083 44.9583 45.425 44.575C45.0417 44.1917 44.5667 44 44 44H36V56ZM48.5 56H51.5V44H48.5V56ZM54 56H56.5V49L61.6 56H64V44H61.5V51L56.5 44H54V56ZM39 49V47H43V49H39ZM34 66C32.9 66 31.9583 65.6083 31.175 64.825C30.3917 64.0417 30 63.1 30 62V38C30 36.9 30.3917 35.9583 31.175 35.175C31.9583 34.3917 32.9 34 34 34H66C67.1 34 68.0417 34.3917 68.825 35.175C69.6083 35.9583 70 36.9 70 38V62C70 63.1 69.6083 64.0417 68.825 64.825C68.0417 65.6083 67.1 66 66 66H34ZM32 64H68V36H32V64Z",
    fill: "#183883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.1c0ce4473d336b12ef5b562dc9ebb48e.svg";
export { ForwardRef as ReactComponent };